<div class="cx-term-link">
  <cx-link [link]="data" styleClass="link-hover-underline" />
</div>
